const React = require("react");
const PropTypes = require("prop-types");

const Description = ({ children }) => {
  return <p className="pane__description">{children}</p>;
};

Description.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Description;
